ddd<template>
    <transition name="fade">

        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content" style="align:center">
                        <slot />
                        <br>
                        <p class="h4 text-seccess fw-bold" style="color:navy">Product Name</p>
                        <input type="text" name="item_name" v-on:keyup.enter="saveNewProduct()" class="form-control"  id="newproduct_item_name" v-model="item_name" size="25" style="border-color:black"/>
                        <p class="h4 text-seccess fw-bold" style="color:navy">Barcode</p>
                        <input type="text" name="newproductbarcode" v-on:keyup.enter="saveNewProduct()" class="form-control" id="newproductbarcode" v-model="newproductbarcode" size="25" style="border-color:black"/>

                        <p class="h4 text-seccess fw-bold" style="color:navy">Price</p>
                        <input type="text" name="newproductprice" v-on:keyup.enter="saveNewProduct()" class="form-control" id="newproductprice" v-model="newproductprice" size="25" style="border-color:black"/>

                        <button @click="saveNewProduct()" class="btn btn-primary">Save</button>
                        <button @click="handleClose()" class="btn btn-warning">Close</button>
                        <div class="col-sm-4" style="position:fixed;width:250px;height:300px; min-height: 200px;left:0px;bottom:-80px;margin-top: 0px;margin-bottom: 0px;margin-left : 0px;color:#000000; background-color: #1a1f2f;margin-left: -15px;margin-right: -10px;">
                        <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="showKeypad"/>
                        </div>
                    </div>
                </div>

            </transition>
        </div>
    </transition>
</template>
<script>
import axios from "axios";  
import numericpad from "@/components/SimpleKeyboard";
import commonServices from "@/shared/commonServices"

export default {
    mixins: [commonServices],
    components:{   numericpad },
    mounted() {
        this.$el.querySelector('#newproduct_item_name').focus = true;

        if(this.msgItems.length>0){
            this.enter_barcode_or_name = this.msgItems[0].cont;
        }  
    },
    name:"NewProduct",
    data: function(){        
        return {
            showKeypad: true,
            enter_barcode_or_name:'',
            newproductbarcode: '',
            newproductprice: 0,
            item_name: '',
            newProductData: null,
            newProductJson: {},
        }
    },
    methods:{
        onInput(key) {
        if(key == 11){
            this.newproductbarcode = (this.newproductbarcode + "0").slice(0, this.maxLength);
            }else{
            this.newproductbarcode = (this.newproductbarcode + key).slice(0, this.maxLength);
            }
        },
        onDelete() {
        this.checkbarcode = this.checkbarcode.slice(0, this.checkbarcode.length - 1);
        },
        onReset() {
        this.checkbarcode = "";
        document.getElementById("newproductbarcode").style.borderWidth ='1px'; 
        document.getElementById("newproductbarcode").style.borderColor ='black'; 
        },        
        handleClose(){
            this.close();
        },
        passNewProductData()
        {
            this.$emit('getNewProductData', this.newProductData)
        },

        saveNewProduct: async function(){
            try{

                //New Product API
                let dataURL = this.apiURL+'GiftCard/saveNewProduct';
                //let newProductJson = {"appId": localStorage.appId, 'newproductbarcode': this.newproductbarcode, 'newproductprice': this.newproductprice, 'item_name': this.item_name};
                this.newProductJson = {"appId": localStorage.appId,"barcode": this.newproductbarcode, "rate": this.newproductprice, "item_name": this.item_name, "created_by": localStorage.userId};
                let response = await axios.post(dataURL, this.newProductJson); 
                //this.newProductData = response.data;
                this.newProductData = {"newproductbarcode": this.newproductbarcode, "newproductprice": this.newproductprice, "item_name": this.item_name, "item_discount": 0};
             
                this.passNewProductData()
            }
            catch (error){
                console.log(error);
            }
            this.close();
        }

    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
        products: {
            type:Array,
            required:true
        },
        msgItems: {
            type:Array,
            required:true
        },  
    },
    setup(_, { emit }){    
        const close = () => {              
            emit('close');
        };
        const display = () => {              
        if(this.msgItems.length>0){
            this.enter_barcode_or_name = this.msgItems[0].cont;

        } 

        };
        return { close };
    },
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
}
.vue-modal-inner {
    max-width: 500px;
    margin: 2rem auto;
}
.vue-modal-content {
    position: relative;
    background-color: #fff;
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 500px;
    height: 500px;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
/*
@import "https://unpkg.com/primitive-ui/dist/css/main.css"
*/

</style>
